const translations = {
  "en": {
    "been doing without": "been doing without",
    "The money person you've": "The money person you've"
  },
  "zh-tw": {
    "been doing without": "理財專家",
    "The money person you've": "你一直缺少的"
  }
};

export default translations;
